import * as d3 from "d3";
import { convertSvgAttribute } from "utils/convertSvgAttribute";
export function initAxes(ref, margin) {
  var svg = d3.select(ref);
  var height = convertSvgAttribute(svg.style("height"));
  var width = convertSvgAttribute(svg.style("width"));
  svg.append("g").attr("class", "xTop").attr("transform", "translate(".concat(-width, ",").concat(margin.top, ")"));
  svg.append("g").attr("class", "xBottom").attr("transform", "translate(".concat(-width, ",").concat(height - margin.bottom, ")")).attr("needsPlacement", "true");
}
export function updateAxes(_ref) {
  var svg = _ref.svg,
    x = _ref.x,
    margin = _ref.margin,
    width = _ref.width,
    xTicks = _ref.xTicks;
  var height = convertSvgAttribute(svg.style("height"));
  var calleeTop = d3.axisTop(x).ticks(xTicks).tickSize(0).tickSizeOuter(0).tickPadding(5);
  var calleeBottom = d3.axisBottom(x).ticks(xTicks).tickSize(0).tickSizeOuter(0).tickPadding(5);
  svg.select(".xTop").transition().ease(d3.easeQuad).duration(400).attr("transform", "translate(".concat(margin.left, ",").concat(margin.top, ")")).call(calleeTop);
  if (svg.select(".xBottom").attr("needsPlacement") === "true") {
    svg.select(".xBottom").attr("needsPlacement", "false").attr("transform", "translate(".concat(-width, ",").concat(height - margin.bottom, ")"));
  }
  svg.select(".xBottom").transition().duration(400).call(calleeBottom).attr("transform", "translate(".concat(margin.left, ",").concat(height - margin.bottom, ")"));
  svg.selectAll(".xTop, .xBottom").selectAll("path").style("stroke", "#406E75").style("stroke-width", "2px").style("stroke-linecap", "square");
  svg.selectAll(".tick").selectAll("text").style("font-size", "10px").style("fill", "#406E75").style("letter-spacing", ".5px");
}